import * as React from "react";
const SvgThumbsDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 13H1V2h14.278a3 3 0 0 1 2.966 2.555l.9 6A3 3 0 0 1 16.178 14H13v3.142a1.865 1.865 0 0 1-3.418 1.034l-3.414-5.121L6.131 13H2Zm4-2V4H3v7h3Zm2 1.197 3 4.5V12h5.178a1 1 0 0 0 .989-1.148l-.9-6a1 1 0 0 0-.99-.852H8v8.197Z",
      clipRule: "evenodd"
    })
  );
export default SvgThumbsDown20Px;
